import React, { useEffect, useContext } from "react"
import AuthContext from "../context/AuthContext"
import { useLocation } from "react-router-dom"
import { LinearProgress } from "@material-ui/core"

function Callback() {
    const auth = useContext(AuthContext)
    const location = useLocation()

    useEffect(() => {
        if (/access_token|id_token|error/.test(location.hash) && auth) {
            auth.handleAuthentication()
        } else {
            throw new Error("invalid callback url")
        }
    }, [auth, location])

    return <LinearProgress />
}

export default Callback
